import axios from "axios";

export const NOTICE_GROUP_URL = "/NoticeGroup";

/** Belli Bir Duyuru Grubu Listesini Elde Eder */
export function getNoticeGroups(queryParams) {
  return axios.post(`${NOTICE_GROUP_URL}/GetNoticeGroups`, queryParams);
}

/** Belli Bir Duyuru Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllNoticeGroups(queryParams) {
  return axios.post(`${NOTICE_GROUP_URL}/GetAllNoticeGroups`, queryParams);
}

/** Yeni Bir Duyuru Grubu Elde Eder */
export function getNewNoticeGroup() {
  return axios.get(NOTICE_GROUP_URL);
}

/** Belli Bir Duyuru Grubunu Elde Eder */
export function getNoticeGroup(id) {
  return axios.get(`${NOTICE_GROUP_URL}/${id}`);
}

/** Belli Bir Duyuru Grubunu Kaydeder */
export function saveNoticeGroup(noticeGroup) {
  return axios.post(NOTICE_GROUP_URL, noticeGroup);
}

/** Belli Bir Duyuru Grubu Listesini Siler */
export function deleteNoticeGroups(ids) {
  return axios.post(`${NOTICE_GROUP_URL}/Delete`, { ids });
}